import React, { useEffect } from 'react';
import { StickyBanner } from '../components/StickyBanner';
import { PopupNotification } from '../components/PopupNotification';
import { Hero } from '../components/Hero';
import { DeviceMockup } from '../components/DeviceMockup';
import { Story } from '../components/Story';
import { Problem } from '../components/Problem';
import { Method } from '../components/Method';
import { Results } from '../components/Results';
import { Included } from '../components/Included';
import { Testimonials } from '../components/Testimonials';
import { Value } from '../components/Value';
import { Guarantee } from '../components/Guarantee';
import { Cost } from '../components/Cost';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Share } from '../components/Share';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    // Initialize Meta Pixel PageView
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-brand-dark text-brand-light font-sans overflow-x-hidden" data-id="element-395">
      <StickyBanner data-id="element-396" />
      <PopupNotification data-id="element-397" />

      <main className="mt-[50px]" data-id="element-398">
        <Hero data-id="element-399" />
        <Story data-id="element-400" />
        <Problem data-id="element-401" />
        <Method data-id="element-402" />
        <Results data-id="element-403" />
        <Included data-id="element-404" />
        <Testimonials data-id="element-405" />
        <Value data-id="element-406" />
        <Guarantee data-id="element-407" />
        <Cost data-id="element-408" />
        <FAQ data-id="element-409" />
        <FinalCTA data-id="element-410" />
        <Share data-id="element-411" />
      </main>

      <Footer data-id="element-412" />
    </div>;
}